import React from "react";
import createImageUrlBuilder from "@sanity/image-url";
import { createClient } from "next-sanity";
import useTranslation from "next-translate/useTranslation";
import Footer from "../../SanityComponents/Footer/Footer";
import style from "./style.module.css";
import AnnoncesLpHeader from "SanityComponents/AnnoncesLpHeader";
import AnnoncesLpHeaderImage from "SanityComponents/AnnoncesLpHeaderImage";

import GroupFormLp from "SanityComponents/GroupFormLp";
import LinksComponent from "SanityComponents/LocationAnnoncesLp/LinksComponent";
import page_grid from "styles/global/page_grid.module.css";
import NewAideCards from "SanityComponents/NewAideCards";
import WhatssapComponent from "SanityComponents/WhatssapComponent";
import AnnuaireByRegion from "components/AnnuaireAgence/HomePage/AnnuaireByRegion";
import { useRouter } from "next/router";
import SanityHeadSeo from "../../sanity/Components/SanityHeadSeo/SanityHeadSeo";

const client = createClient({
  apiVersion: "2023-01-01",
  dataset: "production" || "production",
  projectId: "n2i0cmq4" || "",
  useCdn: false,
});
function urlFor(source) {
  return createImageUrlBuilder(client).image(source);
}

export function AgnecesImmobiliere(props: { slug: string; data: any | null }) {
  const { t, lang } = useTranslation("common");

  const { data } = props;
  const router = useRouter();

  return (
    <div style={{ top: "66px", position: "relative" }}>
      {/* {data?.content?.map((item, key) => {
        if (item._type == "lpheader") {
          return (
            <AnnoncesLpHeaderImage
              backgroundUrl={
                item.background_image
                  ? urlFor(item.background_image)
                    .format("webp")
                    .auto("format")
                    .fit("clip")
                    .auto("format")
                    .toString()
                  : null
              }
              agenceImmo={true}
              t={t}
              lang={lang}
            />
          );
        }
      })} */}
      <div>
        {data?.content.map((item, key) => {
          if (item._type == "lpheader") {
            return (
              <div className={style.parentContainerHead}>
                <div className={style.innerContainer}>
                  <AnnoncesLpHeader
                    index={key}
                    title={item.titre ? item.titre[lang] : ""}
                    subtitle={item.soustitre ? item.soustitre[lang] : null}
                    secondeSubtitle={
                      item.secondsoustitre ? item.secondsoustitre[lang] : null
                    }
                    overlay={item.overlay_image ? item.overlay_image : null}
                    content={item.content ? item.content : null}
                    backgroundUrl={
                      item.background_image
                        ? urlFor(item.background_image)
                            .format("webp")
                            .auto("format")
                            .fit("clip")
                            .auto("format")
                            .toString()
                        : null
                    }
                    imagePosition={item.makePicOnBackground}
                    searchBar={item.SearchBar}
                    agenceImmo={true}
                    t={t}
                    lang={lang}
                  />
                </div>
              </div>
            );
          } else if (item._type == "SanityHeadSeo") {
            return (
              <SanityHeadSeo
                key={key}
                title={item.titre ? item.titre[lang] : ""}
                ogTitle={item.titre ? item.titre[lang] : ""}
                description={item.description ? item.description[lang] : ""}
                ogDescription={item.description ? item.description[lang] : ""}
                canonicalUrl={item.canonicalUrl ? item.canonicalUrl : ""}
                ogTwitterImage={
                  item.mainImage
                    ? urlFor(item.mainImage)
                        .width(250)
                        .height(250)
                        .format("webp")
                        .auto("format")
                        .fit("clip")
                        .auto("format")
                        .toString()
                    : null
                }
                ogType={item.ogType ? item.ogType : null}
                ogImageUrl={
                  item.mainImage
                    ? urlFor(item.mainImage)
                        .width(250)
                        .height(250)
                        .format("webp")
                        .auto("format")
                        .fit("clip")
                        .auto("format")
                        .toString()
                    : null
                }
                structuredData={null}
              >
                <></>
              </SanityHeadSeo>
            );
          } else if (item.card) {
            return (
              <div className={style.parentContainer}>
                {item.card?.AideCards?.length > 0 && (
                  <div className={style.innerContainer}>
                    <div className={style.AgencesCardsTitle}>
                      {item.card.titre ? <p>{item.card?.titre[lang]}</p> : null}
                    </div>
                    <div className={style.AgencesCards}>
                      {item.card?.AideCards?.map((elem, index) => {
                        return (
                          <>
                            {elem && (
                              <NewAideCards
                                title={elem.titre ? elem.titre[lang] : ""}
                                text={elem.text ? elem.text[lang] : ""}
                                icon={
                                  elem.mainImage
                                    ? urlFor(elem.mainImage)
                                        .format("webp")
                                        .auto("format")
                                        .fit("clip")
                                        .auto("format")
                                        .toString()
                                    : null
                                }
                              />
                            )}
                          </>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            );
          } else if (
            item?.annoncesLpLinksObject?.AnnoncesLpLinksArray?.length > 0
          ) {
            return (
              <>
                <p className={style.TitleLinks}>Agence immobilière par ville</p>
                <div className={style.parentContainer}>
                  <div
                    className={style.innerContainer}
                    style={{ width: "100%" }}
                  >
                    <LinksComponent
                      data={
                        item.annoncesLpLinksObject?.AnnoncesLpLinksArray
                          ? item.annoncesLpLinksObject.AnnoncesLpLinksArray
                          : null
                      }
                      lang={lang}
                      isFlex={
                        item.annoncesLpLinksObject?.isFlex
                          ? item.annoncesLpLinksObject.isFlex
                          : null
                      }
                    />
                  </div>
                </div>
              </>
            );
          } else {
            return (
              <>
                {item?.AnnoncesLpLinksArray?.length > 0 ? (
                  <div className={style.parentContainer}>
                    <div className={style.innerContainer}>
                      <LinksComponent
                        data={
                          item.AnnoncesLpLinksArray
                            ? item.AnnoncesLpLinksArray
                            : null
                        }
                        lang={lang}
                      />
                    </div>
                  </div>
                ) : null}
                {/* {item._type == "SubHeader" ?
                  <div className={style.parentContainerAnn}>
                      <AnnuaireByRegion
                        router={router}
                        title={item.titre ? item.titre[lang] : ""}
                      />
                   </div>
                  : null} */}
                {item._type == "SanityFooter" ? (
                  <div className={style.parentContainer}>
                    <div className={style.innerContainer}>
                      <Footer
                        propos={item.propos ? item.propos[lang] : null}
                        proposText={item.text ? item.text[lang] : ""}
                        donnee={item.donnees ? item.donnees[lang] : null}
                        donneeText={
                          item.textdonnee ? item.textdonnee[lang] : null
                        }
                        technologie={
                          item.technologie ? item.technologie[lang] : null
                        }
                        technologieText={
                          item.texttechnologies
                            ? item.texttechnologies[lang]
                            : null
                        }
                        logo={
                          item.agenz_logo
                            ? urlFor(item.agenz_logo)
                                .format("webp")
                                .auto("format")
                                .fit("clip")
                                .auto("format")
                                .toString()
                            : null
                        }
                        facebook={
                          item.facebook_logo
                            ? urlFor(item.facebook_logo)
                                .format("webp")
                                .auto("format")
                                .fit("clip")
                                .auto("format")
                                .toString()
                            : null
                        }
                        instagram_logo={
                          item.instagram_logo
                            ? urlFor(item.instagram_logo)
                                .format("webp")
                                .auto("format")
                                .fit("clip")
                                .auto("format")
                                .toString()
                            : null
                        }
                        linked_in={
                          item.linkedin_logo
                            ? urlFor(item.linkedin_logo)
                                .format("webp")
                                .auto("format")
                                .fit("clip")
                                .auto("format")
                                .toString()
                            : null
                        }
                        socialMediaText={
                          item.socialMediatext ? item.socialMediatext : null
                        }
                        copyRightText={
                          item.permission_text ? item.permission_text : null
                        }
                      />
                    </div>
                  </div>
                ) : null}
              </>
            );
          }
        })}
      </div>
    </div>
  );
}
